import React, { useState, useEffect } from 'react';

interface OnboardingCard {
  card_name: string;
  card_image: string;
  search_uri: string;
}

interface OnboardingCardsProps {
  onSearch: (searchUri: string) => void;
}

export const OnboardingCards: React.FC<OnboardingCardsProps> = ({ onSearch }) => {
  const [cards, setCards] = useState<OnboardingCard[]>([]);

  useEffect(() => {
    fetch('/search_onboarding/cards.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load onboarding cards');
        return res.json();
      })
      .then(setCards)
      .catch(() => setCards([]));
  }, []);

  if (cards.length === 0) return null;

  return (
    <div className="w-full max-w-[400px] lg:max-w-[500px] mx-auto">
      <h3 className="text-[17px] font-bold text-[#132B64] tracking-wide mb-3 px-1">
        Suggested Profile for you
      </h3>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-hide">
        {cards.map((card) => (
          <button
            key={card.search_uri}
            onClick={() => onSearch(card.search_uri)}
            className="flex-shrink-0 w-[121px] bg-[#E7EEE3] rounded-[10px] shadow-[0px_1px_8px_2px_rgba(0,0,0,0.1)] overflow-hidden text-left transition-transform hover:scale-[1.03] active:scale-[0.98]"
          >
            <div className="p-[6px] pb-0">
              <img
                src={card.card_image}
                alt={card.card_name}
                className="w-[110px] h-[134px] object-cover rounded-[9px]"
              />
            </div>
            <div className="px-2 py-3 text-center">
              <span className="text-sm font-medium text-[#132B64] tracking-wide">
                {card.card_name}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
